<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <path
        :stroke="color"
        d="M15.5.809L12.978 2.07 10.5.583 8 2.083 5.5.583 3.022 2.07.5.809v16.382l2.522-1.261L5.5 17.417l2.5-1.5 2.5 1.5 2.478-1.487 2.522 1.261V.809z"
      />
      <rect width="8" height="1" x="4" y="5" :fill="color" rx=".5" />
      <rect width="8" height="1" x="4" y="8" :fill="color" rx=".5" />
      <rect width="8" height="1" x="4" y="11" :fill="color" rx=".5" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
